import {AfterViewInit, Component, HostListener, OnDestroy} from '@angular/core';
import {GoftinoService} from "@app/core/goftino.service";
import {IndicatorService} from "@app/shared";
import {interval, Subscription} from "rxjs";
import {BackKeyUrlService} from "@app/components/header/back-key-url.service";

@Component({
  selector: 'navaar-goftino',
  template: '',
})
export class GoftinoComponent implements AfterViewInit, OnDestroy {
  @HostListener('window:goftino_openWidget', ['$event'])
  goftinoOpenWidget(e) {
    this.goftinoService.isOpenGoftino = true;
  }

  @HostListener('window:goftino_closeWidget', ['$event'])
  goftinoCloseWidget(e) {
    if (this.goftinoService.isOpenGoftino) {
      this.goftinoService.isOpenGoftino = false;
      if (!this.subscription.closed)
        this.subscription.unsubscribe();
      this.backKeyUrlService.goBack(null, true);
    }
  }

  private subscription: Subscription = new Subscription();

  constructor(
    private readonly backKeyUrlService: BackKeyUrlService,
    private readonly indicator: IndicatorService,
    private readonly goftinoService: GoftinoService) {
  }

  ngAfterViewInit(): void {
    this.subscription.add(interval(1000).subscribe(z => {
      if (this.goftinoService.isLoadedGoftino) {
        try {
          this.goftinoService.openWidget();
          this.indicator.hide();
          const unreadKey = Object.keys(localStorage)
            .find(x =>
              x.startsWith('goftino_unread'));
          localStorage.setItem(unreadKey, '0');
          this.subscription.unsubscribe();
        } catch {
          this.ngAfterViewInit();
        }
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
